import { useEffect } from 'react';
import { PrivacyPolicyContent } from './PrivacyPolicyContent';

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='page-bg'>
      <div className='terms-policy'>
        <div className='container'>
          <div dangerouslySetInnerHTML={{ __html: PrivacyPolicyContent }}></div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
